module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0070.jpg?v=0b0ec6b6";